import { render, staticRenderFns } from "./ChartDataManagement.vue?vue&type=template&id=0bb78481&"
import script from "./ChartDataManagement.vue?vue&type=script&lang=js&"
export * from "./ChartDataManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChartDataManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports